import script from "./chose-service-lite.vue?vue&type=script&setup=true&lang=js"
export * from "./chose-service-lite.vue?vue&type=script&setup=true&lang=js"

import "./chose-service-lite.vue?vue&type=style&index=0&id=1c2688ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c2688ec"]])

export default __exports__